import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableConfig } from '../generic-table/class/TableConfig';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TableColumn } from '../generic-table/class/TableColumn';
import { debounceTime } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-generic-search-label',
  imports: [
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './generic-search-label.component.html',
  styleUrl: './generic-search-label.component.css',
})
export class GenericSearchLabelComponent implements OnInit {
  @Input({ required: true }) listElements: any[] = [];
  @Input({ required: true }) tableConfig: TableConfig = new TableConfig();
  @Input({ required: true }) endPoint: string = '';

  @Output() queryEmit = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder) {
    this.searchForm = this.formBuilder.group({
      research: [''],
    });
  }

  query: string = '';

  request: string = '';
  listColumnsResearchable: TableColumn[] = [];

  listeFiltered: any[] = [];

  searchForm: FormGroup;

  ngOnInit(): void {
    for (var column of this.tableConfig.columns) {
      if (column.researchable == true) {
        this.listColumnsResearchable.push(column);
      }
    }
    this.searchForm.valueChanges.pipe(debounceTime(300)).subscribe((res) => {
      let value = res.research;

      if (value) {
        this.query = '';
        for (var col of this.listColumnsResearchable) {
          if (col.type == undefined) {
            let property: string = col.searchOn ? col.searchOn : col.id;
            this.query += `${property}==*${value}*,`;
          }
        }
        this.query = this.query.substring(0, this.query.length - 1);

        this.queryEmit.emit(this.query);
      } else {
        this.queryEmit.emit(undefined);
      }
    });
  }
}
